module.exports = __webpack_public_path__ + "img/jamaica.a0be218.webp";